/**
 * The missing half of the update flow (found 2026-08-04 — "the refresh button doesn't do
 * anything"): `updateServiceWorker` tells the waiting worker to activate, but the page
 * keeps running the OLD bundle until something reloads it. Activation fires
 * `controllerchange`; reload exactly once when it does. Guarded so an unrelated
 * controller change (first install) can't loop.
 *
 * Imported for side effects from main.tsx (not from UpdateToast, which only mounts inside
 * AppShell) so every route — including the public /login, /invite/:token, /play/:token
 * routes — arms this guard at startup. A tab that only ever visits a public route must
 * still catch the controllerchange or it keeps running stale JS against a new SW (the
 * "stale bundle" failure mode, see docs/DECISIONS.md 2026-08-03/08-04 entries).
 */
let reloadedOnControllerChange = false;
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  // Snapshot: was this page already controlled? First-install activation (no prior
  // controller) must not refresh a page mid-first-visit; version swaps must.
  const wasControlled = navigator.serviceWorker.controller !== null;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloadedOnControllerChange || !wasControlled) return;
    reloadedOnControllerChange = true;
    window.location.reload();
  });
}
